import { yupResolver } from "@hookform/resolvers/yup";
import { ButtonSet, Form, Loading } from "carbon-components-react";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import CancelButton from "../../components/Buttons/CancelButton";
import SubmitButton from "../../components/Buttons/SubmitButton";
import BusinessIdeaForm from "../../components/Forms/BusinessIdeaForm";
import BusinessProfileForm from "../../components/Forms/BusinessProfileForm";
import CompetitorDataForm from "../../components/Forms/CompetitorDataForm";
import ExecutiveSummaryForm from "../../components/Forms/ExecutiveSummaryForm";
import Card from "../../components/Card/Card";
import {
  basicApplicationSchema,
  basicBusinessPlanSchema,
} from "../../services/SchemaService";
import useAuth from "../../hooks/useAuth";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import http from "../../http-common";
import { Tabs } from "carbon-components-react";
import { Tab } from "carbon-components-react";
import { Button } from "carbon-components-react";
import { ArrowRight20 } from "@carbon/icons-react";
import { ArrowLeft20 } from "@carbon/icons-react";
import ApplicationFillingInstructions from "../../components/Miscellaneous/ApplicationFillingInstructions";
import BusinessPlanFillingInstructions from "../../components/Miscellaneous/BusinessPlanFillingInstructions";
import EnvironmentalSocialAnalysisForm from "../../components/Forms/EnvironmentalSocialAnalysisForm";
import FinancialPlanForm from "../../components/Forms/FinancialPlanForm";
import EmployeesForm from "../../components/Forms/WorkersForm";
import MarketAnalysisForm from "../../components/Forms/MarketAnalysisForm";
import CapacityAnalysisForm from "../../components/Forms/CapacityAnalysisForm";
import BusinessPlanIdeaForm from "../../components/Forms/BusinessPlanIdeaForm";
import ExistingBusinessProfileForm from "../../components/Forms/ExistingBusinessProfileForm";
import DataSheetForm from "../../components/Forms/DataSheetForm";
import WorkersForm from "../../components/Forms/WorkersForm";
import useBusinessPlan from "../../hooks/useBusinessPlan";

const UpdateBusinessPlanPage = () => {
  const params = useParams();
  const [uuid] = useState(params.uuid);
  const { businessPlan } = useBusinessPlan(uuid);
  const [hasBusinessCurrently, setHasBusinessCurrently] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const { user, isCompetitor } = useAuth();
  const [districts, setDistricts] = useState([]);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  const {
    register,
    handleSubmit,
    reset,
    getValues,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(basicBusinessPlanSchema),
    mode: "onBlur",
  });

  const onSubmit = async (data) => {
    console.log(data);
    try {
      const response = await http.put(`/business-plan/${params.uuid}`, data);
      toast.success("Plano de Negócio actualizado com sucesso");
      navigate("../plano-de-negocio/" + uuid);
    } catch (error) {
      toast.error(error?.response?.data.message);
    }
  };

  useEffect(() => {
    reset(businessPlan);
    setHasBusinessCurrently(businessPlan.hasBusinessCurrently);
    setTimeout(() => {
      setIsLoading(false);
    }, "2000");
  }, [uuid, businessPlan]);

  const nextTab = () => {
    setActiveTab((prev) => prev + 1);
  };
  const previousTab = () => {
    setActiveTab((prev) => prev - 1);
  };

  return (
    <Card title="Editar Plano de Negócio">
      <Loading
        active={isLoading}
        description="Active loading indicator"
        withOverlay={true}
      />
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Tabs
          scrollIntoView={false}
          selected={activeTab}
          type={"container"}
          onSelectionChange={(e) => setActiveTab(e)}
        >
          <Tab href="#" id="tab-0" label="INSTRUÇÕES">
            <BusinessPlanFillingInstructions />
            <div className="tab-navigation">
              <p></p>
              <Button kind="ghost" size="sm" onClick={nextTab}>
                Próximo <ArrowRight20 />
              </Button>
            </div>
          </Tab>
          <Tab href="#" id="tab-1" label="SECÇÃO 1">
            <DataSheetForm
              register={register}
              control={control}
              errors={errors}
              hasBusinessCurrently={hasBusinessCurrently}
              setHasBusinessCurrently={setHasBusinessCurrently}
              businessPlan={businessPlan}
            />
            <div className="tab-navigation">
              <Button kind="ghost" size="sm" onClick={previousTab}>
                <ArrowLeft20 /> Anterior
              </Button>
              <Button kind="ghost" size="sm" onClick={nextTab}>
                Próximo <ArrowRight20 />
              </Button>
            </div>
          </Tab>
          {hasBusinessCurrently !== null && hasBusinessCurrently === "Sim" && (
            <Tab href="#" id="tab-2" label="SECÇÃO 2">
              <ExistingBusinessProfileForm
                register={register}
                errors={errors}
                setHasBusinessCurrently={setHasBusinessCurrently}
                businessPlan={businessPlan}
              />
              <div className="tab-navigation">
                <Button kind="ghost" size="sm" onClick={previousTab}>
                  <ArrowLeft20 /> Anterior
                </Button>
                <Button kind="ghost" size="sm" onClick={nextTab}>
                  Próximo <ArrowRight20 />
                </Button>
              </div>
            </Tab>
          )}
          <Tab href="#" id="tab-4" label="SECÇÃO 3">
            <BusinessPlanIdeaForm register={register} errors={errors} />
            <div className="tab-navigation">
              <Button kind="ghost" size="sm" onClick={previousTab}>
                <ArrowLeft20 /> Anterior
              </Button>
              <Button kind="ghost" size="sm" onClick={nextTab}>
                Próximo <ArrowRight20 />
              </Button>
            </div>
          </Tab>
          <Tab href="#" id="tab-4" label="SECÇÃO 4">
            <CapacityAnalysisForm register={register} errors={errors} />
            <div className="tab-navigation">
              <Button kind="ghost" size="sm" onClick={previousTab}>
                <ArrowLeft20 /> Anterior
              </Button>
              <Button kind="ghost" size="sm" onClick={nextTab}>
                Próximo <ArrowRight20 />
              </Button>
            </div>
          </Tab>
          <Tab href="#" id="tab-4" label="SECÇÃO 5">
            <MarketAnalysisForm register={register} errors={errors} />
            <div className="tab-navigation">
              <Button kind="ghost" size="sm" onClick={previousTab}>
                <ArrowLeft20 /> Anterior
              </Button>
              <Button kind="ghost" size="sm" onClick={nextTab}>
                Próximo <ArrowRight20 />
              </Button>
            </div>
          </Tab>
          <Tab href="#" id="tab-4" label="SECÇÃO 6">
            <WorkersForm register={register} errors={errors} />
            <div className="tab-navigation">
              <Button kind="ghost" size="sm" onClick={previousTab}>
                <ArrowLeft20 /> Anterior
              </Button>
              <Button kind="ghost" size="sm" onClick={nextTab}>
                Próximo <ArrowRight20 />
              </Button>
            </div>
          </Tab>
          <Tab href="#" id="tab-4" label="SECÇÃO 7">
            <FinancialPlanForm
              register={register}
              errors={errors}
              businessPlan={businessPlan}
              getValues={getValues}
            />
            <div className="tab-navigation">
              <Button kind="ghost" size="sm" onClick={previousTab}>
                <ArrowLeft20 /> Anterior
              </Button>
              <Button kind="ghost" size="sm" onClick={nextTab}>
                Próximo <ArrowRight20 />
              </Button>
            </div>
          </Tab>
          <Tab href="#" id="tab-8" label="SECÇÃO 8">
            <EnvironmentalSocialAnalysisForm
              businessPlan={businessPlan}
              register={register}
              errors={errors}
            />
            <div className="tab-navigation">
              <Button kind="ghost" size="sm" onClick={previousTab}>
                <ArrowLeft20 /> Anterior
              </Button>
            </div>
          </Tab>
        </Tabs>
        <ButtonSet>
          <SubmitButton />
          <CancelButton />
        </ButtonSet>
      </Form>
    </Card>
  );
};

export default UpdateBusinessPlanPage;
